// extracted by mini-css-extract-plugin
export default {"errorType":"wd2TN","warningIcon":"QEG79"};